import { ViewExportType } from "@redotech/cockroachdb-codegen/congodb/view-export-type";
import { ViewExportScope } from "@redotech/redo-views-common/view-exports";
import { viewSchemas } from "@redotech/redo-views-common/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createViewExport = {
  name: "createViewExport" as const,
  input: z.object({
    view: viewSchemas["fulfillment-groups"],
    exportType: createEnum(ViewExportType),
    exportScope: createEnum(ViewExportScope),
    selectedDocumentIds: z.array(z.string()).optional(),
    sendToEmail: z.string().email(),
    expectedCount: z.number().optional(),
  }),
  output: z.object({ exportId: z.string(), fileUrl: z.string().optional() }),
};
